import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { ThemeContext, LanguageContext, UserContext, ActionContext } from "../../contexts/Context";
import axios from "axios";
import { IoCloseOutline, IoLogoInstagram } from "react-icons/io5";
import Modal from '../optioncomponents/Modal';
import CusPdpa from './CustomerPdpa';
import CusRegister from "./CustomerRegister";
import CusForgot from './CustomerForgot';
import { getRecentBought } from "./CustomerRecentAPI";
import promo from './Promotion';
import {
    getAssetUrl,
    getCompanyAddress,
    getCompanyPhone,
    getInstagramInfo,
    getOperatingHours
} from "./loginDisplayUtil";
// import { customer } from '../../screens/customer';

const CustomerLogin = ({ show, setShow, handleCallback, initialPhone = "", initialName = "", initialPassword = "", submitOnOpen = false, registerOnly = false }) => {
    // registerOnly opens straight into sign up; the login drawer stays hidden
    const [revealLogin, setRevealLogin] = useState(!submitOnOpen && !registerOnly);
    const [displayShow, setDisplay] = useState(show ? "flex" : "none");
    const themeContext = React.useContext(ThemeContext);
    const languageContext = React.useContext(LanguageContext);
    const { addCustomer, addPromotion, setRecentItem, addToCart } = React.useContext(ActionContext);
    const {
        lanIndex, token, userId, company, allowRegister, pm: promotion, hideOptionalField, recentBought, cart,
        bgImg, landingImg, otherUrls, openingTime, closingTime
    } = React.useContext(UserContext);
    const [phone, setPhone] = useState(initialPhone);
    const [pin, setPin] = useState(initialPassword);
    const submittedInitialCredentials = React.useRef(false);
    const [warningMsg, setWarningMsg] = useState("");
    const [error, setError] = useState([]);
    const [showError, setShowError] = useState(false);
    const [showPdpa, setShowPdpa] = useState(false);
    const [showRegister, setShowRegister] = useState(registerOnly);
    const [showForgot, setShowForgot] = useState(false);
    const [processing, setProcessing] = useState(false);
    useEffect(() => {
        setDisplay(show ? "flex" : "none");

    }, [show]);

    useEffect(() => {
        if (!registerOnly && (showError || warningMsg)) setRevealLogin(true);
    }, [showError, warningMsg, registerOnly]);

    const closeRegister = (value) => {
        setShowRegister(value);
        if (registerOnly && !value) setShow(false);
    };

    const submitRegister = (customer) => {
        if (processing) return;
        if (token && userId) {
            setProcessing(true);
            axios.post(`/v2/api/customer`,
                customer,
                {
                    headers: { Authorization: "Bearer " + token },
                })
                .then(function (response) {
                    setProcessing(false);
                   
                    if (response.status == 200) {
                        setShowRegister(false);
                        addCustomer(response.data.customer);
                        let pm = JSON.parse(JSON.stringify(promotion || []));
                        if (response.data.customer && response.data.customer.promotion) {
                            pm = pm.concat(response.data.customer.promotion);
                        }
                        pm.sort((a, b) => (a.eventPriority < b.eventPriority) ? 1 : -1);
                        localStorage.setItem("promotion", JSON.stringify(pm));
                        addPromotion(pm);
                        //update cart
                        let newCart = JSON.parse(JSON.stringify(cart));
                        if (newCart && newCart.length > 0) {
                            newCart = promo.clearPromotion(newCart);
                            newCart = promo.applyPromotion(pm, newCart);
                            addToCart(newCart);
                        }

                        localStorage.setItem("customer", JSON.stringify(response.data.customer));
                        setError([{ errorMessage: "Register Successfully" }]);
                        setShowError(true);
                        if (handleCallback)
                            handleCallback(response.data.customer);
                        setShow(false);
                    } else {
                        setWarningMsg("Something went wrong. Please try again");
                    }

                })
                .catch(function (error) {
                    //show warning
                    setProcessing(false);
                    if (error.response && error.response.status == 402) {
                       
                        setError([{ errorMessage: "Phone No has been used" }]);
                        setShowError(true);
                    } else {
                      
                        setError([{ errorMessage: "Something went wrong. Please try again" }]);
                        setShowError(true);
                    }
                })
        }
    };

    const memberSubmit = () => {
        if (phone == "") {
            setWarningMsg("Phone No is required");
            return;

        } else if (!hideOptionalField && pin == "") {
            setWarningMsg("Pin is required");
            return;
        }
        if (processing) return;
        setProcessing(true);
        if (token && userId) {
            axios.post(`/v2/api/customer/login`,
                {
                    userId: userId,
                    phone: phone,
                    password: pin
                },
                {
                    headers: { Authorization: "Bearer " + token },
                })
                .then(function (response) {
                    setProcessing(false);
                  
                    if (response.status == 200) {
                        addCustomer(response.data);
                        let pm = JSON.parse(JSON.stringify(promotion || []));
                        if (response.data.promotion) {
                            pm = pm.concat(response.data.promotion);
                        }
                        pm.sort((a, b) => (a.eventPriority < b.eventPriority) ? 1 : -1);
                        localStorage.setItem("promotion", JSON.stringify(pm));
                        addPromotion(pm);

                        //update cart
                        let newCart = JSON.parse(JSON.stringify(cart));
                        if (newCart && newCart.length > 0) {
                            newCart = promo.clearPromotion(newCart);
                            newCart = promo.applyPromotion(pm, newCart);
                            addToCart(newCart);
                        }
                        if (recentBought) {
                            getRecentBought(phone, token).then(res => {
                                setRecentItem(res);
                            })
                        }

                        localStorage.setItem("customer", JSON.stringify(response.data));
                        if (handleCallback)
                            handleCallback();
                        setShow(false);
                    }

                })
                .catch(function (error) {
                    //show warning
              
                    setProcessing(false);
                 
                    if (error.response && error.response.status == 401) {
                        setError([{ errorMessage: "Invalid phone no or password" }]);
                        setShowError(true);
                    } else {
                      
                        setError([{ errorMessage: "Something went wrong. Please try again" }]);
                        setShowError(true);
                    }
                })


        }
    }

    const forgotPwd = (e) => {
        setShowForgot(true);
    }

    const register = (e) => {
        setShowRegister(true);
    }
    const handleChange = (e, name) => {
        if (name == 'phone') {
            setPhone(e);
        } else {
            setPin(e);
        }
        setWarningMsg("");
    }

    const operatingHours = getOperatingHours(openingTime, closingTime);
    const companyAddress = getCompanyAddress(company);
    const companyPhone = getCompanyPhone(company);
    const instagramInfo = getInstagramInfo(otherUrls);

    useEffect(() => {
        if (!show) submittedInitialCredentials.current = false;
        if (show && submitOnOpen && token && userId && !submittedInitialCredentials.current) {
            submittedInitialCredentials.current = true;
            memberSubmit();
        }
    }, [show, submitOnOpen, token, userId]);

    return (
        //phone, name, email, dob, gender password
        <React.Fragment>
            <DrawerBackdrop display={revealLogin ? displayShow : "none"} onClick={() => setShow(false)} />
            <ModalContainer display={revealLogin ? displayShow : "none"} bgImg={bgImg} themeContext={themeContext}>
                <IconButton onClick={() => setShow(false)}>
                    <IoCloseOutline size={34} />
                </IconButton>
                <ContentWrapper>
                    <FormSection>
                        <ImgWrapper image={company && company.companyLogo} />
                        <TitleText>SIGN IN</TitleText>
                        <WarningMsg themeContext={themeContext}>
                            {warningMsg}
                        </WarningMsg>
                        <Input
                            value={phone}
                            onChange={(e) => { handleChange(e.target.value, 'phone') }}
                            placeholder={`${languageContext[lanIndex].phone}*`}
                            type="tel"
                            aria-label={languageContext[lanIndex].phone}
                        />
                        {!hideOptionalField &&
                            <Input
                                type="password"
                                value={pin}
                                onChange={(e) => { handleChange(e.target.value, 'pin') }}
                                placeholder="Password*"
                                aria-label="Password"
                            />
                        }
                        <ForgotButton onClick={forgotPwd}>
                            Forgot your password?
                        </ForgotButton>
                        <LoginButton onClick={memberSubmit} >
                            SIGN IN
                        </LoginButton>
                        {allowRegister &&
                            <RegisterButton onClick={register}>
                                CREATE A NEW ACCOUNT
                            </RegisterButton>
                        }
                    </FormSection>
                    {(landingImg || operatingHours || companyPhone || companyAddress || instagramInfo) &&
                        <FooterInfo>
                            {landingImg && <FooterLandingImage image={landingImg} />}
                            {operatingHours && <FooterLine>{operatingHours}</FooterLine>}
                            {companyPhone && <FooterLine>{companyPhone}</FooterLine>}
                            {companyAddress && <FooterAddress>{companyAddress}</FooterAddress>}
                            {instagramInfo && instagramInfo.url &&
                                <InstagramLink href={instagramInfo.url} target="_blank" rel="noopener noreferrer">
                                    <IoLogoInstagram size={46} />
                                    {instagramInfo.handle && <InstagramHandle>{instagramInfo.handle.split("?")[0]}</InstagramHandle>}
                                </InstagramLink>
                            }
                        </FooterInfo>
                    }
                </ContentWrapper>

            </ModalContainer>
            <Modal
                show={showError}
                setShow={setShowError}
                error={error}
                fontFamily={'"contralto-xsmall", sans-serif'}
            />
            <CusRegister
                initialPhone={phone}
                initialName={initialName}
                show={show && showRegister}
                setShow={closeRegister}
                setShowError={setShowError}
                setError={setError}
                onSubmit={submitRegister}
                setShowPdpa={setShowPdpa} />
            <CusPdpa
                show={showPdpa}
                setShow={setShowPdpa}
                setShowError={setShowError}
                setError={setError}
            />
            <CusForgot
                show={showForgot}
                setShow={setShowForgot}
                setShowError={setShowError}
                setError={setError}
            />
        </React.Fragment >
    );
}

export default CustomerLogin;

const DrawerBackdrop = styled.div`
    display: none;

    @media (min-width: 768px) {
        display: ${(props) => props.display};
        position: fixed;
        inset: 0;
        z-index: 998;
        background: rgba(0, 0, 0, 0.38);
        animation: memberDrawerBackdrop 180ms ease-out;

        @keyframes memberDrawerBackdrop {
            from { opacity: 0; }
            to { opacity: 1; }
        }
    }
`;

const WarningMsg = styled.div`
    min-height: 20px;
    margin: 6px 0 12px;
    color: ${(props) => props.themeContext.fontAlert};
`;

const LoginButton = styled.div`
    display: flex;
    width: 68%;
    max-width: 360px;
    min-height: 62px;
    margin: 0 auto;
    justify-content: center;
    background-color: #5f5f5f;
    color: #ffffff;
    align-items: center;
    font-size: 24px;
    font-weight: 400;
    border-radius: 34px;
    box-shadow: 0px 2px 5px rgba(0,0,0,0.18);
    cursor: pointer;

    @media (max-height: 760px) {
        min-height: 54px;
        font-size: 21px;
    }
`;

const ForgotButton = styled.div`
    align-self: flex-end;
    margin: -4px 8px 30px 0;
    font-size: 16px;
    color: #505050;
    cursor: pointer;
`;

const RegisterButton = styled.div`
    margin-top: 24px;
    font-family: "contralto-xsmall", sans-serif;
    font-size: 16px;
    font-weight: 600;
    color: #444444;
    text-decoration: underline;
    cursor: pointer;
`;
const ImgWrapper = styled.div`
    width: 220px;
    max-width: 78%;
    height: 220px;
    margin: 0 0 20px;
    background-image: ${(props) => props.image ? `url(${getAssetUrl(props.image)})` : "none"};
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;

    @media (max-height: 760px) {
        width: 180px;
        height: 120px;
        margin-bottom: 14px;
    }
`;

const Input = styled.input`
    width: 100%;
    min-height: 76px;
    border-radius: 12px;
    padding: 0 26px;
    font-size: 24px;
    border: 1px solid #9d9d9d;
    margin-bottom: 18px;
    background-color: rgba(255,255,255,0.94);
    color: #343434;
    box-sizing: border-box;
    outline: none;

    &::placeholder {
        color: #a9a9a9;
    }

    @media (max-height: 760px) {
        min-height: 62px;
        font-size: 20px;
        margin-bottom: 12px;
    }
`;

const IconButton = styled.div`
  position: absolute;
  right: 20px;
  top: 20px;
  z-index: 99;
  color: #555555;
  cursor: pointer;
`;

const TitleText = styled.div`
    font-family: "contralto-xsmall", sans-serif;
    color: #333333;
    font-size: 30px;
    font-weight: 300;
    line-height: 1;

    @media (max-height: 760px) {
        margin-bottom: 20px;
        font-size: 26px;
    }
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    min-height: 100dvh;
    box-sizing: border-box;
    padding: 44px 32px 34px;
    overflow-y: auto;
    gap: 34px;

    @media (max-height: 760px) {
        padding-top: 28px;
        gap: 22px;
    }
`;

const FormSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 500px;
    padding-top: 16px;
`;

const FooterInfo = styled.div`
    width: 100%;
    max-width: 520px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #555555;
    text-align: center;
`;

const FooterLandingImage = styled.div`
    width: 80%;
    height: 100px;
    margin-top: 100px;
    background-image: ${(props) => props.image ? `url(${getAssetUrl(props.image)})` : "none"};
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    
    @media (max-height: 760px) {
        height: 72px;
    }
`;

const FooterLine = styled.div`
    margin-top: 6px;
    font-size: 21px;
    line-height: 1.15;
`;

const FooterAddress = styled.div`
    max-width: 430px;
    margin-top: 10px;
    font-size: 15px;
    font-style: italic;
    line-height: 1.25;
`;

const InstagramLink = styled.a`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    margin-top: 42px;
    color: #555555;
    text-decoration: none;

    @media (max-height: 760px) {
        margin-top: 24px;
    }
`;

const InstagramHandle = styled.div`
    font-size: 14px;
    font-weight: 600;
`;

const ModalContainer = styled.div`
    display: ${(props) => props.display};
    font-family: "contralto-xsmall", sans-serif;
    position: fixed;
    flex-direction: column;
    background-color: ${(props) => props.themeContext.backgroundColor};
    background-image: ${(props) => props.bgImg ? `url(${getAssetUrl(props.bgImg)})` : "none"};
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    top: 0;
    left: max(0px, calc((100vw - 550px) / 2));

    width: 100vw;
    max-width: 550px;
    height: 100vh;
    height: 100dvh;
    z-index: 8;

    *, input, button, textarea, select {
        font-family: "contralto-xsmall", sans-serif !important;
    }

    animation: modalOrder .1s;
    animation-timing-function: ease-out;
    @keyframes modalOrder {
        0%  {
        transform: translateY(350px);
        opacity: 0;
        }
        
        100%  {
        transform: translateY(0px);
        opacity: 1;
        }
        
    }

    @media (min-width: 768px) {
        right: 0;
        left: auto;
        width: min(420px, 92vw);
        max-width: none;
        z-index: 999;
        box-shadow: -14px 0 38px rgba(0, 0, 0, 0.22);
        animation: memberDrawer 220ms cubic-bezier(0.22, 1, 0.36, 1);

        @keyframes memberDrawer {
            from {
                transform: translateX(100%);
                opacity: 0.65;
            }
            to {
                transform: translateX(0);
                opacity: 1;
            }
        }
    }

  `;
